import { render, staticRenderFns } from "./AlertRSActionsTable.vue?vue&type=template&id=0f4e89a6&scoped=true&"
import script from "./AlertRSActionsTable.vue?vue&type=script&lang=js&"
export * from "./AlertRSActionsTable.vue?vue&type=script&lang=js&"
import style0 from "./AlertRSActionsTable.vue?vue&type=style&index=0&id=0f4e89a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4e89a6",
  null
  
)

export default component.exports